import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-operacao',
  templateUrl: './operacao.component.html',
  styleUrls: ['./operacao.component.css']
})
export class OperacaoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
